import React, { useEffect, useRef } from 'react';
import './Experiences.css';

const SLIDER_SELECTOR = '.tv-image-slider.tv-moduleid-9995375';

const runTourvisorInit = () => {
  try {
    if (typeof window.TV?.loadModules === 'function') {
      window.TV.loadModules();
      return;
    }
    if (typeof window.TV?.init === 'function') window.TV.init();
    if (typeof window.Tv?.init === 'function') window.Tv.init();
    if (typeof window.tourvisorInit === 'function') window.tourvisorInit();
  } catch (err) {
    console.warn('Tourvisor slider init error:', err);
  }
};

const Experiences = () => {
  const mountKeyRef = useRef(Date.now());

  useEffect(() => {
    let cancelled = false;
    const timers = [];

    const ensureSlider = () => {
      if (cancelled) return;
      const el = document.querySelector(SLIDER_SELECTOR);
      if (!el) return;

      // Уже есть контент — не трогаем (иначе получается второй набор слайдов)
      if (el.childElementCount > 0) return;

      // tv-loaded при пустом контейнере = init ещё идёт / оборван — не снимаем флаг
      // повторно, только если loadModules ещё не помечал узел
      if (el.classList.contains('tv-loaded')) return;

      runTourvisorInit();
    };

    const boot = () => {
      // Небольшая пауза: init.js из index.html тоже вызывает loadModules
      timers.push(window.setTimeout(ensureSlider, 150));
      // Повтор только если слайдер так и не появился
      [1200, 3000, 6000].forEach((delay) => {
        timers.push(window.setTimeout(ensureSlider, delay));
      });
    };

    if (window.TV?.loadModules || window.TV?.init) {
      boot();
    } else {
      const waitId = window.setInterval(() => {
        if (window.TV?.loadModules || window.TV?.init) {
          window.clearInterval(waitId);
          boot();
        }
      }, 100);
      timers.push(waitId);
      timers.push(
        window.setTimeout(() => {
          window.clearInterval(waitId);
          boot();
        }, 8000)
      );
    }

    return () => {
      cancelled = true;
      timers.forEach((id) => {
        window.clearTimeout(id);
        window.clearInterval(id);
      });
    };
  }, []);

  return (
    <section className="experiences-section page-section">
      <div className="page-container">
        <h2 className="section-title">Популярные направления</h2>
        <p className="section-subtitle">
          Подборка туров, которые чаще всего выбирают наши клиенты.
        </p>

        <div className="experiences-tourvisor-slider" key={mountKeyRef.current}>
          <div className="tv-image-slider tv-moduleid-9995375" />
        </div>
      </div>
    </section>
  );
};

export default Experiences;
